import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { MessageBannerMiddleware } from '@nhl/nhl-react-ui/lib/MessageBanner';

import * as reducers from './ducks';
import rootSaga from './sagas';
import { actionSanitizer, stateSanitizer } from './sanitizers';

export default function configureStore(initialState) {
    const sagaMiddleware = createSagaMiddleware();
    const appReducer = combineReducers({ ...reducers });
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ actionSanitizer, stateSanitizer })
        : compose;
    const store = createStore(
        appReducer,
        initialState,
        composeEnhancers(applyMiddleware(sagaMiddleware, MessageBannerMiddleware)),
    );

    sagaMiddleware.run(rootSaga);

    return store;
}
